import { css } from '@emotion/react';

const mulishFontStyles = css`
    body,
    #body,
    :host,
    input,
    textarea,
    select,
    button {
        font-family: 'Mulish', sans-serif;
        letter-spacing: -0.24px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #06132b;
    }
`;

export default mulishFontStyles;
